import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1920",
  height: "300",
  viewBox: "0 0 1920 300"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M953.5 25.1664C174.75 82.7609 0 25.1663 0 25.1663V1424.98C0 1424.98 174.75 1379.16 953.5 1424.98C1732.25 1470.8 1920 1423.63 1920 1423.63V26.8574C1920 26.8574 1732.25 -32.4281 953.5 25.1664Z",
  stroke: "none"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }